import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const header = () => {
  const body = document.querySelector("body");
  const header = body.querySelector("header.header");
  const headerHome = header.classList.contains("js-header-home");

  function toggleMenu() {
    const burger = header.querySelector(".header-burger");
    const popupMenu = header.querySelector(".popup-menu");
    let leaveTimer = null;

    // Set initial closed state via GSAP so autoAlpha owns visibility
    gsap.set(popupMenu, { height: 0, autoAlpha: 0 });

    function openMenu() {
      clearTimeout(leaveTimer);
      if (header.classList.contains("menu-open")) return;

      header.classList.add("menu-open");
      body.classList.add("no-scroll");
      popupMenu.removeAttribute('aria-hidden');
      popupMenu.removeAttribute('inert');

      if (burger) {
        burger.setAttribute('aria-expanded', 'true');
      }

      const targetHeight =
        window.innerWidth >= 1024
          ? popupMenu.scrollHeight
          : window.innerHeight - header.offsetHeight;

      gsap.killTweensOf(popupMenu);
      gsap.to(popupMenu, {
        height: targetHeight,
        autoAlpha: 1,
        duration: 0.4,
        ease: "power2.out",
      });
    }

    function closeMenu() {
      clearTimeout(leaveTimer);
      if (!header.classList.contains("menu-open")) return;

      header.classList.remove("menu-open");
      body.classList.remove("no-scroll");
      popupMenu.setAttribute('aria-hidden', 'true');
      popupMenu.setAttribute('inert', '');

      if (burger) {
        burger.setAttribute('aria-expanded', 'false');
      }

      gsap.killTweensOf(popupMenu);
      gsap.to(popupMenu, {
        height: 0,
        autoAlpha: 0,
        duration: 0.3,
        ease: "power2.in",
      });
    }

    burger.addEventListener("mouseenter", function () {
      if (screen.width > 1180) {
        openMenu();
      }
    });

    header.addEventListener("mouseleave", function () {
      leaveTimer = setTimeout(closeMenu, 100);
    });

    header.addEventListener("mouseenter", function () {
      clearTimeout(leaveTimer);
    });

    burger.addEventListener("click", function () {
      if (!header.classList.contains("menu-open")) {
        openMenu();
      } else {
        closeMenu();
      }
    });

    document.addEventListener("click", function (event) {
      if (header.classList.contains("menu-open") && !header.contains(event.target)) {
        closeMenu();
      }
    });

    // Close menu when pressing Escape
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        if (header.classList.contains('menu-open')) {
          closeMenu();
        }
      }
    });

    // Close menu when an anchor link is clicked
    document.addEventListener('anchor:clicked', function () {
      closeMenu();
    });
  }

  function toggleHeaderOnScroll() {
    if (!headerHome) {
      return;
    }

    const activationPoint = window.innerHeight / 2;

    ScrollTrigger.create({
      start: 0,
      end: "max",
      onUpdate: (self) => {
        if (self.scroll() >= activationPoint) {
          header.classList.remove("header--transparent");
          return;
        } else {
          header.classList.add("header--transparent");
          return;
        }
      },
    });

    ScrollTrigger.update();
  }

  return {
    init() {
      toggleMenu();
      toggleHeaderOnScroll();
    },
  }
}

export {
  header,
}
